import CacheMap from '../form/CacheMap';
import config from './config';

export default async function validateWithApi(
  url,
  value,
  errorMessage = config.defaultErrorMessage
) {
  const cache = new CacheMap(`fetch_${url}`);
  let result;
  const query = `${url}?string=${encodeURIComponent(value)}`;
  if (cache.has(query)) {
    result = cache.get(query);
  } else {
    const response = await fetch(query);
    result = await response.json();
    cache.set(query, result);
  }

  return result.result === true ? undefined : errorMessage;
}
